import  React, { useEffect }  from 'react';
// import Chatbot from './components/Chatbot';

import '@n8n/chat/style.css';
import './App.css';
import { createChat } from '@n8n/chat';


const App = () => {
	useEffect(() => {
		createChat({
			webhookUrl: 'https://equanimous.app.n8n.cloud/webhook/ff41d2a1-4ffb-4e22-8101-92d61e11ba19/chat',
			initialMessages: [
				'Hi I am Krishna. How can I assist you today?'
			],
			mode: 'fullscreen',
			i18n: {
				en: {
					title: 'Jai Shri Krishna! 🙏',
					subtitle: "Ask any question regarding life and get wisdom from the Bhagvad Gita",
					footer: '',
					getStarted: 'New Conversation',
					inputPlaceholder: 'Type your question..',
				},
			},
		});
	}, []);

	return (<div></div>);
};
export default App